<template>

  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <SmallSquare class="" content='配置公众号的菜单，可创建最多3个一级菜单，每个一级菜单下可创建最多5个二级菜单。' :padding='false'>
      </SmallSquare>
      <div class="s_flex_bian_c m-t-20">
        <div class="s_flex_ali">
          <InfoCircleOutlined class="s_c376 m-r-10" />
          <p class="s_c999">编辑中的菜单不能直接在用户手机上生效，你需要进行发布，发布后24小时内所有的用户都将更新到新的菜单。</p>
        </div>
        <a-button type="primary" ghost v-has:wxMenuSynchro="()=>$router.push('/wxPublic/wxBase/index')">同步微信内容</a-button>
      </div>
      <div class="s_flex_bian m-t-25 ">
        <div class="s_po_re">
          <div class="height-75  p-t-25 s_flex_bian_c contentTopBox s_bor_b_cd9" style="background-color: #fff;">
            <LeftOutlined class="s_c333 fz-18 m-l-20" />
            <p class="s_c333 fz-15">一物一码营销官</p>
            <UserOutlined class="s_c333 fz-18 m-r-20" />
          </div>
          <div class="iphoneBox s_po_re">
            <div class="contentTopBot s_bor_t_cd9 ">
              <transition-group appear tag="div">
                <div class="s_flex_bian_c width100">
                  <p class="height-40 s_flex_center width18"><img class="width-25 height-25" src="@/assets/images/jianpan.png" alt=""></p>
                  <p class="height-30 s_bor_l_cd9 s_flex_center s_shou flex_1" v-for='(item,index) in button' @click="setBtn(index,-1)" :key='index' draggable="true" :class="position.length==1&&position[0]==index?'active':''" @dragstart="dragstart(item,'one')" @dragenter="dragenter(item,'one')" @dragend="dragend(item,'one')">
                    <a-popover>
                      <template #content>
                        <div class="twobutton">
                          <p class="s_bor_t_cd9 height-40 s_flex_center s_shou" v-for='(items,indexs) in item.sub_button' :key='indexs' draggable="true" :class="position.length==2&&position[0]==index&&position[1]==indexs?'active':''" @dragstart="dragstart(items,'two')" @dragenter="dragenter(items,'two')" @dragend="dragend(items,'two',index)" @click="setBtn(index,indexs)">{{items.name}}</p>
                          <p class="s_bor_t_cd9 height-40 s_flex_center s_shou" @click="setBtn(index,item.sub_button.length)" v-if='(!item.sub_button||item.sub_button.length < 5)&&!item.type'>
                            <PlusOutlined />添加子菜单
                          </p>
                        </div>
                      </template>
                      <p>{{item.name}}</p>
                    </a-popover>
                  </p>
                  <p class=" flex_1 s_shou s_flex_center s_bor_l_cd9 height-30 " :class="position.length==1&&position[0]==button.length?'active':''" v-if=' button.length < 3' @click="setBtn(button.length)">
                    <PlusOutlined />添加
                  </p>
                </div>
              </transition-group>
            </div>
          </div>
        </div>
        <div class="width70 p-20" style="background-color: #f7f7f7;" v-show="position.length">
          <div class="height-50 s_flex_bian_c s_bb1_cd0d m-b-25">
            <p class="fz-16 s_font_b">菜单名称</p>
            <div>
              <a-button type="link" v-has:wxMenuDel='delMenu'>删除</a-button>
            </div>
          </div>
          <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-item ref="name" label="菜单名称" name="name" :rules="[{ required: true, message: '请输入菜单名称' }]">
              <a-row :gutter="16">
                <a-col :span="14">
                  <a-input v-model:value="form.name" placeholder='请输入菜单名称' @blur="setData" @input="inputMenu" />
                </a-col>
                <a-col :span="10">{{tabType == "one" ? "字数不超过8个字节" : "字数不超过240个字节"}}(一个汉字两个字节)</a-col>
              </a-row>
              <!-- <a-checkbox class="m-t-10" v-model:checked="form.value">开启专属海报功能</a-checkbox>-->
            </a-form-item>
            <a-form-item ref="sub_button" name="sub_button" hidden v-if="position[1]!=-1">
              <a-input v-model:value="form.sub_button" />
            </a-form-item>
            <div v-if="!form.sub_button||form.sub_button.length==0">
              <a-form-item ref="radio" label="菜单内容" name="radio">
                <a-radio-group v-model:value="form.radio">
                  <a-radio :value="1">发送消息</a-radio>
                  <a-radio :value="2">跳转网页</a-radio>
                  <a-radio :value="3">跳转小程序</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="消息设置" v-if='form.radio == 1' :rules="[{ required: true, message: '请输入文字' }]">
                <a-tabs class="s_bf" v-model:activeKey='activeKey'>
                  <a-tab-pane key="click">
                    <template #tab>
                      <span>
                        <EditOutlined />文字
                      </span>
                    </template>
                    <div class="p-b-10 p-l-15 p-r-15">
                      <a-textarea v-model:value="form.menu_text" showCount :maxlength="600" :rows='8' placeholder='请输入' @blur="setData" />
                    </div>
                  </a-tab-pane>
                  <a-tab-pane key="media_id">
                    <template #tab>
                      <span>
                        <PictureOutlined />图片
                      </span>
                    </template>
                    <div class="s_flex_bian_c p-l-15 p-r-15 p-b-10">
                      <!--  <div class="imgTextBox s_flex_center width49">
                        <div class="text-ac">
                          <PlusOutlined class="s_c999 fz-40" />
                          <p class="s_c999">从素材库中选择</p>
                        </div>
                      </div>-->
                      <wxMaterial :image="form.file_url" :max="1" v-on:handlechoose="(data)=>{form.file_url=data.imageUrl;form.media_id=data.data.media_id,setData()}" v-on:handledel="form.media_id='';form.file_url=''" />
                      <a-form-item ref="media_id" name="media_id" hidden label="media_id">
                        <a-input v-model:value="form.media_id" />
                      </a-form-item>
                      <a-form-item ref="file_url" name="file_url" hidden label="file_url">
                        <a-input v-model:value="form.file_url" />
                      </a-form-item>
                    </div>
                  </a-tab-pane>
                  <a-tab-pane key="view_limited">
                    <template #tab>
                      <span>
                        <FileImageOutlined />图文
                      </span>
                    </template>
                    <div class="s_flex_ali p-l-15 p-r-15 p-b-10" v-if="!form.media_content">
                      <div class="imgTextBox s_flex_center width49" @click="graphicVisible=true">
                        <div class="text-ac">
                          <PlusOutlined class="s_c999 fz-40" />
                          <p class="s_c999">从素材库中选择</p>
                        </div>
                      </div>
                      <router-link tag='div' to="/wxPublic/wxManagement/drewManagement/wx_imgText_add?type=add" class=" s_flex_center imgTextBox width49">
                        <div class="text-ac ">
                          <PlusOutlined class="s_c999 fz-14 m-b-10" />
                          <p class="s_c999">新建图文消息</p>
                        </div>
                      </router-link>
                    </div>
                    <div v-else class='mediaContent s_flex_ali'>

                      <div class="content">
                        <div class="media_header p-t-10 p-b-10 m-b-5">{{form.media_content.create_time}}</div>
                        <div class="media_main m-b-10" :style="{backgroundImage:'url('+info.picdomain+'/'+form.media_content.list[0].file_url+')'}">
                          <img src="@/assets/images/bgmoren.jpg" alt="" v-if="!form.media_content.list[0].file_url">
                        </div>
                        <div class="media_foot s_flex_bian_c">
                          {{form.media_content.list[0].title}}<a-button type="link" @click="delMedia">删除</a-button>
                        </div>
                      </div>
                    </div>
                  </a-tab-pane>
                  <!-- 音频 -->
                  <a-tab-pane key="audio_id">
                    <template #tab>
                      <span>
                        <CustomerServiceOutlined />音频
                      </span>
                    </template>
                    <!--  -->
                    <div class="audio_select" v-if="!audioData.media_id" @click="audioStuts=true">
                      <plus-outlined style="fontSize:18px"></plus-outlined>
                      <p class="m-t-10">选择音频</p>
                    </div>
                    <div class="select_success" v-else>
                      <div class="audio_success">
                        <img src="@/assets/images/audio.png" alt="" width="100" height="96">
                        <div class="m-l-10 flex_1 s_flex_ali p-r-5">
                          <p class="s_omit2 flex_1">{{audioData.name || '无'}}</p>
                        </div>
                      </div>
                      <div class="m-l-20">
                        <span style="color:#05486A" class="cursor_p" @click="delAudio">删除</span>
                      </div>
                    </div>
                    <!--  -->
                  </a-tab-pane>
                  <!-- 视频 -->
                  <a-tab-pane key="view_id">
                    <template #tab>
                      <span>
                        <PlaySquareOutlined />视频
                      </span>
                    </template>
                    <div class="s_flex_center s_mauto m-t-20 m-b-50" style="width:70%">
                      <a-input v-model:value="videoData.wx_file_url" placeholder="请选择视频链接" style="flex:1" />
                      <a-button type="primary" class="m-l-10" @click="videoStuts=true">选择</a-button>
                      <a-button type="primary" class="m-l-10 copy-btn" :data-clipboard-text="videoData.wx_file_url" @click="copy()">复制链接</a-button>
                    </div>
                  </a-tab-pane>
                </a-tabs>
              </a-form-item>
              <a-form-item v-if='form.radio == 2' :rules="[{ required: true, message: '请设置链接地址' }]" name="url" label='网络地址:'>
                <div class="s_flex_ali">
                  <a-input class="width90 m-r-20" v-model:value="form.url" @blur="setData" />
                  <a-button type="primary" @click='visibleLink = true'>设置</a-button>
                </div>
                <!--    <div class="s_bor_cbed s_bf">
                  <div class="s_flex_bian">
                    <p class="height-50 s_bb1 s_flex_center width50">设置页面链接</p>
                    <p class="height-50 s_bb1 s_bl1 s_flex_center width50">点击复制链接</p>
                  </div>
                  <div class="s_flex_bian">
                    <div class="s_flex_center width50">
                      <p class="">链接：</p>
                      <p class="width60 s_omit">{{form.url?form.url:'请设置链接地址'}}</p>
                      <a-button type="link" @click='visibleLink = true'>设置</a-button>
                    </div>
                    <div class="s_bl1 p-t-10 p-b-10 width50">
                      <p class="text-ac s_lin_h35" v-for='item in copyLink' :key='item'>{{item.name}}</p>
                    </div>
                  </div>
                </div>-->
              </a-form-item>
              <a-form-item v-if='form.radio == 3' :rules="[{ required: true, message: '请设置小程序的页面路径' }]">
                <!--隐藏域-->
                <div v-show="false">
                  <a-form-item label="小程序appid" name="appid">
                    <a-input v-model:value="form.appid" placeholder='请输入小程序appid' />
                  </a-form-item>
                  <a-form-item label="小程序页面路径" name="pagepath">
                    <a-input v-model:value="form.pagepath" placeholder='请输入小程序页面路径' />
                  </a-form-item>
                  <a-form-item label="备用网页" name="url">
                    <a-input v-model:value="form.url" placeholder='请输入备用网页' />
                  </a-form-item>
                </div>
                <div class="s_flex_center s_bf m-b-10">
                  <p class="">链接：</p>
                  <p class="width62 s_omit">{{form.pagepath?form.pagepath:'请设置小程序的页面路径'}}</p>
                  <a-button type="link" @click='visiblePage = true;visibleType=1'>设置</a-button>
                </div>
                <div class="s_flex_center s_bf">
                  <p class="">备用网页:</p>
                  <p class="width60 s_omit">{{form.url?form.url:'请设置小程序的备用网页'}}</p>
                  <a-button type="link" @click='visiblePage = true;visibleType=2'>设置</a-button>
                </div>
              </a-form-item>
            </div>
          </a-form>
          <a-form-item :wrapper-col="{ span: 14, offset: 3 }">
            <a-button type="primary" v-has:wxMenuSubmit="create" class='m-r-10'>提交</a-button>
            <a-button type="danger" v-has:wxMenuRelease="submit">发布</a-button>
          </a-form-item>
        </div>
      </div>

    </a-card>
  </a-layout>
  <a-modal :keyboard="false" title="选择图文" :width='1000' centered :footer="null" v-model:visible="graphicVisible" destroyOnClose>
    <graphic v-on:success="success" v-on:cancel="graphicVisible=false" />
  </a-modal>
  <a-modal :keyboard="false" title="功能页面链接" :width='1000' centered :footer="null" v-model:visible="visibleLink" destroyOnClose>
    <webUrl :url='form.url' @select='chooseWebPagePath'></webUrl>
  </a-modal>
  <a-modal :keyboard="false" title="选择小程序页面路径" :width='800' centered :footer="null" v-model:visible="visiblePage" destroyOnClose>
    <links :AppletStatus="false" :webStatus="visibleType==1" v-on:success="selecLink" />
    <!-- <div class="card-container">
      <a-tabs type="card">
        <a-tab-pane key="1" tab="云店小程序">
          <div class="s_ptb0lr24">
            <div class="s_flex_bian_c m-b-15" v-for='item in pages' :key='item'>
              <p class="">{{item.title}}</p>
              <a-button type="primary" ghost @click="choosePagePath(item)">选择</a-button>
            </div>
          </div>
          <div class="s_ptb0lr24" style="border-top: 1px solid #f0f0f0;">
            <p class="m-b-10 p-t-25">自定义云店小程序页面路径：</p>
            <div class=" s_flex_bian">
              <a-form-item name="pagepath" class="width88">
                <a-input v-model:value="form.pagepath" placeholder="请输入小程序页面路径"></a-input>
              </a-form-item>
              <a-button type="primary" class='m-t-1' @click="comfirmPath">确定</a-button>
            </div>
            <p class="m-b-10">备用网页：</p>
            <div class=" s_flex_bian">
              <a-form-item name="url">
                <a-input class="width88 m-b-10" v-model:value="form.url" placeholder="请输入备用网页"></a-input>
              </a-form-item>
              <a-button type="primary" class='m-t-1' @click="comfirmPath">确定</a-button>
            </div>
            <p class="p-b-25">旧版微信不支持微信小程序，请设置备用网页以防报错</p>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="关联小程序">
          <div class="">
            <p class="m-b-25 p-l-20">微信公众号仅支持跳转已关联的小程序，请先确保需要跳转的小程序已关联至当前公众号。<a-button type="link">设置指引</a-button>
            </p>
            <a-form-item ref="" label="小程序appid" name="appid" :label-col="{span:4}" :wrapper-col="{span:18}">
              <a-input v-model:value="form.appid" placeholder='请输入小程序appid' />
            </a-form-item>
            <a-form-item ref="" label="小程序页面路径" name="pagepath" :label-col="{span:4}" :wrapper-col="{span:18}">
              <a-input v-model:value="form.pagepath" placeholder='请输入小程序页面路径' />
            </a-form-item>
            <a-form-item ref="" label="备用网页" name="url" :label-col="{span:4}" :wrapper-col="{span:18}" help='旧版微信不支持微信小程序，请设置备用网页以防报错'>
              <a-input v-model:value="form.url" placeholder='请输入备用网页' />
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 8, offset: 4 }">
              <a-button type="primary" @click="visiblePage=false;setData()">确定</a-button>
            </a-form-item>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div> -->
  </a-modal>

  <a-modal :keyboard="false" title="选择音频" :width='1000' centered :footer="null" v-model:visible="audioStuts" destroyOnClose>
    <!-- <webUrl :url='form.url' @select='chooseWebPagePath'></webUrl> -->
    <audioModal @change="audioSelect"></audioModal>
  </a-modal>

  <a-modal :keyboard="false" title="选择视频" :width='1000' centered :footer="null" v-model:visible="videoStuts" destroyOnClose>
    <videoModal :videoID="vid" @change="videoSelect"></videoModal>
  </a-modal>
</template>
<script>
import {
  InfoCircleOutlined,
  LeftOutlined,
  UserOutlined,
  EditOutlined,
  PictureOutlined,
  FileImageOutlined,
  PlusOutlined,
  CustomerServiceOutlined,
  PlaySquareOutlined,
} from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import {
  getwx_facility,
  setwx_facility,
  getMiniPage,
  savewx_facility,
  getWxMaterialVoice,
  getWxMaterial,
  getWxMaterialVideo,
  getWxGraphicMore,
  getAppID,
} from "@/api/public_wx";
import { iscode } from "@/utils/app"; // 初始化默认筛选项数值
import store from "@/store";
import webUrl from "./webUrl";
import Clipboard from "clipboard";
import audioModal from "./components/audioModal.vue";
import videoModal from "./components/videoModal.vue";
import config from "@/config";
let oss = config.oss[process.env.VUE_APP_type];
let defForm = {
  name: "",
  
};
export default {
  components: {
    InfoCircleOutlined,
    LeftOutlined,
    UserOutlined,
    EditOutlined,
    PictureOutlined,
    FileImageOutlined,
    PlusOutlined,
    webUrl,
    CustomerServiceOutlined,
    PlaySquareOutlined,
    audioModal,
    videoModal,
  },
  setup(props) {
    const state = reactive({
      appid: "",
      visibleLink: false,
      visiblePage: false,
      audioStuts: false,
      videoStuts: false,
      info: store.state.user.info,
      button: [
        {
          name: "一物一码",
          sub_button: ["一物一码案例", "一物一码历程", "一物一码链接"],
        },
        { name: "功能演示", sub_button: [] },
        { name: "社交电商", sub_button: [] },
      ],

      copyLink: [
        { name: "微商控价-代理后台" },
        { name: "微商控价-代理查询" },
        { name: "门店管理" },
      ],
      tabType: "one",
      labelCol: { span: 3 },
      wrapperCol: { span: 21 },
      oldNum: 0,
      newNum: 0,
      oldNums: 0,
      newNums: 0,
      activeKey: "click",
      graphicVisible: false,
      // 音频
      audioList: [],
      loading: false,
      audioData: {},
      // 视频
      videoData: { id: null },
      visibleType: 1,
      app_id: "",
    });
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    const initData = async () => {
      let result = await getwx_facility()
        .then((res) => res.data)
        .catch((error) => error);
      state.button = result.data;
      // state.button.forEach((v) => {
      //   v.sub_button = v.sub_button ? v.sub_button : [];
      // });
    };
    // 记录初始信息
    const dragstart = (value, type) => {
      if (type == "one") {
        state.oldNum = value;
      } else {
        state.oldNums = value;
      }
    };
    // 做最终操作
    const dragend = (value, type, index) => {
      if (type == "one") {
        if (state.oldNum != state.newNum) {
          let oldIndex = state.button.indexOf(state.oldNum);
          let newIndex = state.button.indexOf(state.newNum);
          let newItem = [...state.button];
          // 删除老的节点
          newItem.splice(oldIndex, 1);
          // 在列表中目标位置增加新的节点
          newItem.splice(newIndex, 0, state.oldNum);
          // this.items一改变，transition-group就起了作用
          state.button = [...newItem];
        }
      } else {
        if (state.oldNums != state.newNums) {
          let oldIndexs = state.button[index].list.indexOf(state.oldNums);
          let newIndexs = state.button[index].list.indexOf(state.newNums);
          let newItems = [...state.button[index].list];
          // 删除老的节点
          newItems.splice(oldIndexs, 1);
          // 在列表中目标位置增加新的节点
          newItems.splice(newIndexs, 0, state.oldNums);
          // this.items一改变，transition-group就起了作用
          state.button[index].list = [...newItems];
        }
      }
    };
    // 记录移动过程中信息
    const dragenter = (value, type) => {
      if (type == "one") {
        state.newNum = value;
      } else {
        state.newNums = value;
      }
    };
    // 获取小程序页面列表
    const pages = ref([]);
    const getMiniPages = async () => {
      let result = await getMiniPage()
        .then((res) => res.data)
        .catch((error) => error);
      pages.value = result.data.list;
      state.appid = result.data.appid;
    };

    // 创建
    const position = ref([]); //定义一个位置 表示选中的按钮
    const ruleForm = ref();
    const _lodash = inject("_lodash");
    const form = ref(defForm);
    // 定义各种子按钮类型的集合 对应radio框
    const radioType = [
      //这里对应着radio
      ["click", "view_limited", "media_id", "audio_id", "view_id"],
      ["view"],
      ["miniprogram"],
    ];
    const subType = {
      click: {
        key: "text_0",
        type: "click",
      },
      view: {
        type: "view",
      },
      miniprogram: {
        type: "miniprogram",
      },
      media_id: {
        type: "media_id",
      },
      view_limited: {
        type: "media_id",
      },
      audio_id: {
        type: "media_id",
      },
      view_id: {
        type: "media_id",
      },
    };
    // 设置数据
    const setData = () => {
      ruleForm.value.validate().then((e) => {
        console.log(position.value, "00000");
        // if (position.value[1]==-1) {
        //   // 主菜单
        //   state.button[position.value[0]] = _lodash.cloneDeep(e);
        // } else if (position.value.length == 2) {
        // 子菜单
        if (position.value[1] == -1) {
          state.button[position.value[0]] = _lodash.cloneDeep(e);
        } else {
          state.button[position.value[0]].sub_button[position.value[1]] =
            _lodash.cloneDeep(e);
        }

        console.log(state.activeKey, "key");
        if (e.radio == 1) {
          var data = {};
          if (state.activeKey == "click") {
            data = {
              menu_text: form.value.menu_text,
              menu_type: "text",
            };
          } else if (state.activeKey == "media_id") {
            data = {
              material_type: "img",
              menu_type: "img",
            };
            console.log("进入", data);
          } else if (state.activeKey == "view_limited") {
            data = {
              media_content: JSON.parse(
                JSON.stringify(form.value.media_content)
              ),
              material_type: "news",
              menu_type: "news",
            };
            if (form.value.media_content.media_id) {
              data.media_id = form.value.media_content.media_id;
            } else {
              data.click = "click";
              data.key = "high_" + position.value[0] + "" + position.value[1];
            }
          } else if (state.activeKey == "audio_id") {
            data = {
              ...state.audioData,
              material_type: "voice",
              menu_type: "voice",
            };
            delete data.name;
          } else if (state.activeKey == "view_id") {
            data = {
              ...state.videoData,
              material_type: "video",
              menu_type: "video",
            };
            delete data.name;
          }
          console.log(position.value,data)
          if (position.value[1] == -1) {
            Object.assign(
              state.button[position.value[0]],
              subType[state.activeKey],
              data
            );
          } else {
            Object.assign(
              state.button[position.value[0]].sub_button[position.value[1]],
              subType[state.activeKey],
              data
            );
          }
        } else {
          if (position.value[1] == -1) {
            Object.assign(
              state.button[position.value[0]],
              subType[radioType[Number(e.radio) - 1][0] || -1]
            );
          } else {
            Object.assign(
              state.button[position.value[0]].sub_button[position.value[1]],
              subType[radioType[Number(e.radio) - 1][0] || -1]
            );
          }
        }
        // }
      });
    };
    // 选中网络地址
    const chooseWebPagePath = (data) => {
      Object.assign(form.value, data, { url: data.url });
      setData();
      state.visibleLink = false;
    };
    // 选中小程序地址
    const choosePagePath = (data) => {
      Object.assign(form.value, data, { pagePath: data.pagePath });
      setData();
      state.visiblePage = false;
    };
    const comfirmPath = () => {
      state.visiblePage = false;
    };
    // 新建按钮
    const setBtn = async (site, subsite) => {
      console.log(site,subsite)
      let result, type;
      // 重置一些信息
      ruleForm.value.resetFields();
      state.audioData = {};
      state.videoData = { id: null };
      position.value = [site];
      console.log(subsite);
      if (subsite != null && subsite == -1) {
        position.value.push(subsite);
        form.value = state.button[site];
      
        type = state.button[site] ? state.button[site].menu_type : null;
        //选中
        switch (type) {
          case "text":
            form.value.radio = 1;
            state.activeKey = "click";
            form.value.menu_text = form.value.menu_text || "";
            break;
          case "img":
            form.value.radio = 1;
            state.activeKey = "media_id";
            result = await getWxMaterial({
              media_id: form.value.media_id,
            }).then((res) => res.data);
            if (!iscode(result)) return message.error(result.msg);
            form.value.file_url = result.data.file_url
              ? oss + result.data.file_url
              : "";
            form.value.media_id = result.data.media_id || "";
            break;
          case "news":
            form.value.radio = 1;
            state.activeKey = "view_limited";
            result = await getWxGraphicMore({
              media_id: form.value.media_id,
            }).then((res) => res.data);
            if (!iscode(result)) return message.error(result.msg);
            form.value.media_content = result.data || {};
            break;
          case "voice":
            form.value.radio = 1;
            state.activeKey = "audio_id";
            result = await getWxMaterialVoice({
              media_id: form.value.media_id,
            }).then((res) => res.data);
            if (!iscode(result)) return message.error(result.msg);
            state.audioData = result.data || {};
            break;
          case "video":
            form.value.radio = 1;
            state.activeKey = "view_id";
            result = await getWxMaterialVideo({
              media_id: form.value.media_id,
            }).then((res) => res.data);
            if (!iscode(result)) return message.error(result.msg);
            state.videoData = result.data || {};
            break;
          case "view":
            form.value.radio = 2;
            state.activeKey = null;
            break;
          case "miniprogram":
            form.value.radio = 3;
            state.activeKey = null;
            break;
          default:
            break;
        }
      } else if (subsite != null) {
        const hide = message.loading("正在加载中...", 0);
        position.value.push(subsite);
        if (!state.button[site].sub_button) {
          state.button[site].sub_button = [];
        }
        form.value = state.button[site].sub_button[subsite] || defForm;
        type = state.button[site].sub_button[subsite]
          ? state.button[site].sub_button[subsite].menu_type
          : null;

        //选中
        switch (type) {
          case "text":
            form.value.radio = 1;
            state.activeKey = "click";
            form.value.menu_text = form.value.menu_text || "";
            break;
          case "img":
            form.value.radio = 1;
            state.activeKey = "media_id";
            result = await getWxMaterial({
              media_id: form.value.media_id,
            }).then((res) => res.data);
            if (!iscode(result)) return message.error(result.msg);
            form.value.file_url = result.data.file_url
              ? oss + result.data.file_url
              : "";
            form.value.media_id = result.data.media_id || "";
            break;
          case "news":
            form.value.radio = 1;
            state.activeKey = "view_limited";
            result = await getWxGraphicMore({
              media_id: form.value.media_id,
            }).then((res) => res.data);
            if (!iscode(result)) return message.error(result.msg);
            form.value.media_content = result.data || {};
            break;
          case "voice":
            form.value.radio = 1;
            state.activeKey = "audio_id";
            result = await getWxMaterialVoice({
              media_id: form.value.media_id,
            }).then((res) => res.data);
            if (!iscode(result)) return message.error(result.msg);
            state.audioData = result.data || {};
            break;
          case "video":
            form.value.radio = 1;
            state.activeKey = "view_id";
            result = await getWxMaterialVideo({
              media_id: form.value.media_id,
            }).then((res) => res.data);
            if (!iscode(result)) return message.error(result.msg);
            state.videoData = result.data || {};
            break;
          case "view":
            form.value.radio = 2;
            state.activeKey = null;
            break;
          case "miniprogram":
            form.value.radio = 3;
            state.activeKey = null;
            break;
          default:
            break;
        }

        setTimeout(hide);
        //   console.log(type,'类型')
        // state.activeKey = type || "click";

        // radioType.forEach((v, k) => {
        //   if (v.indexOf(type) != -1) {
        //     form.value.radio = Number(k) + 1;
        //   }
        // });
      } else {
        // 重置表单
        if(!state.button[site]){
          state.button.push(defForm)
        }
        form.value = state.button[site] || defForm;
      }
      form.value = _lodash.cloneDeep(form.value);
    };
    // 选择图文信息、
    const media = ref(null);
    const success = (data) => {
      state.graphicVisible = false;
      form.value.media_content = data;
      setData();
    };
    // 删除图文
    const delMedia = () => {
      form.value.media_content = null;
      setData();
    };
    // 删除
    const delMenu = () => {
      if (!position.value.length) message.error("请选择菜单");
      $Modal.confirm({
        centered: true,
        content: "删除后该菜单后,仍未正式生效需要点击保存或者发布才会生效",
        onOk: async () => {
          console.log(position.value);
          if (position.value[1] == -1) {
            // 主菜单
            state.button.splice(position.value[0],1);
            console.log(position.value[0],state.button)
          } else if (position.value.length == 2) {
            state.button[position.value[0]].sub_button.splice(
              position.value[1],
              1
            );
          }
          console.log(state.button)
          let result = await savewx_facility({
            menu_list: JSON.stringify(state.button),
            button:state.button
          })
            .then((res) => res.data)
            .catch((error) => error);
          iscode(result, true);
          setBtn(0);
        },
      });
    };
    const create = () => {
      console.log(state.button, "提交");
      $Modal.confirm({
        centered: true,
        content: "保存后数据在系统同步,但仍未同步到公众号需要手动点击发布",
        onOk: async () => {
          console.log(state.button)
          let result = await savewx_facility({
            menu_list: JSON.stringify(state.button),
            button:state.button
          })
            .then((res) => res.data)
            .catch((error) => error);
          iscode(result, true);
        },
      });
    };
    // 提交
    const submit = async () => {
      $Modal.confirm({
        centered: true,
        content: "发布是个危险动作请确认菜单数据正确",
        onOk: async () => {
          let result = await setwx_facility({
            menu_list: JSON.stringify(state.button),
            button:state.button
          })
            .then((res) => res.data)
            .catch((error) => error);
          iscode(result, true);
        },
      });
    };
    onMounted(() => {
      initData();
      getMiniPages();
      getAppId();
    });
    const inputMenu = (e) => {
      var bytesCount = 0;
      for (var i = 0; i < e.target.value.length; i++) {
        var c = e.target.value.charAt(i);
        if (/^[\u0000-\u00ff]$/.test(c)) {
          //匹配双字节
          bytesCount += 1;
        } else {
          bytesCount += 2;
        }
      }
      if (state.tabType == "one" && bytesCount > 8) {
        form.value.name = "";
      } else if (bytesCount > 40) {
        form.value.name = "";
      }
    };

    const getAppId = async function () {
      let res = await getAppID().then((res) => res.data);
      console.log(res);
      state.app_id = res.data.app_id || "";
    };

    const methods = {
      beforeUpload(file) {
        if (file.type != "audio/mpeg") return message.error("请上传音频类型！");
      },
      copy() {
        let clipboard = new Clipboard(".copy-btn"); // 这里括号里填写上面点击事件绑定的class名
        clipboard.on("success", (e) => {
          message.success("复制成功");
          // 释放内存
          clipboard.destroy();
        });
      },
      videoSelect(data) {
        state.videoData = data || {};
        state.videoStuts = false;
        setData();
      },
      audioSelect(data) {
        state.audioData = data || {};
        //  form.value.media_content = data || {}
        state.audioStuts = false;
        setData();
      },
      delAudio() {
        state.audioData = {};
        setData();
      },
      selecLink(data) {
        // console.log(data)
        if (state.visibleType == 1) {
          form.value.pagepath = data.url || "";
          form.value.url = form.value.url || "#";
        } else {
          form.value.pagepath = form.value.pagepath || "";
          form.value.url = data.url || "#";
        }
        form.value.appid = state.app_id || "";
        state.visiblePage = false;
        setData();
      },
    };
    return {
      form,
      ...toRefs(state),
      dragstart,
      dragend,
      dragenter,
      submit,
      ruleForm,
      position,
      setBtn,
      setData,
      pages,
      choosePagePath,
      create,
      delMenu,
      success,
      media,
      delMedia,
      inputMenu,
      comfirmPath,
      chooseWebPagePath,
      ...methods,
    };
  },
};
</script>
<style lang="less">
.iphoneBox {
  width: 375px;
  height: 749px;
  background-image: url("../../../../assets/images/huawei.png");
  background-size: 100% 100%;
}

.contentTopBox {
  position: absolute;
  left: 10px;
  right: 14px;
  top: 10px;
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
}
.contentTopBot {
  position: absolute;
  left: 12px;
  right: 15px;
  bottom: 11px;
}
.iphonefooter {
  background-color: #333;
  border-radius: 3px;
}

.imgTextBox {
  height: 250px;
  border: 1px dashed #e7e7eb;
  cursor: pointer;
  margin-right: 12px;
  margin-bottom: 12px;
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.imgTextBox:hover {
  border: 1px dashed #05486a;
}
.card-container .ant-tabs {
  border: 1px solid #f0f0f0;
}
.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #f0f0f0;
}
.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}
.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #05486a;
  background: #05486a;
  color: #fff;
  border-radius: 0;
}
.twobutton p:first-child {
  border: 0;
}
.active {
  border: 1px solid #66b6ff;
  background-color: #fff;
  color: #66b6ff;
}

.mediaContent .content {
  height: 300px;
  overflow: hidden;
  width: 50%;
  margin: 10px 1%;
  position: relative;
  border: 1px solid #eee;
  padding: 20px;
  .media_header {
    border-bottom: 1px solid #eee;
  }
  .media_main {
    width: 100%;
    height: 190px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .media_foot {
    font-weight: 600;
  }
}

//
.audio_select {
  width: 340px;
  height: 120px;
  border: 1px dashed #999;
  text-align: center;
  padding: 30px 0 30px;
  background: #f8f8f8;
  color: #999;
  margin: 20px auto 40px;
  cursor: pointer;
  &:hover {
    border: 1px dashed #333;
    color: #333;
  }
}
.select_success {
  width: 460px;
  display: flex;
  margin: 20px auto 40px;
  align-items: center;
  word-wrap: break-word;
  word-break: break-all;
  & .audio_success {
    width: 404px;
    height: 104px;
    border: 2px solid #eee;
    overflow: hidden;
    display: flex;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    padding: 2px;
    border-radius: 5px;
  }
}
</style>